module.exports = __webpack_public_path__ + "img/emailLogoDetailCampus.78308aa.png";